"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const scale_1 = require("../../utils/scale");
const button_1 = require("../button");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const InputField = (props) => {
    const { isRequire = false, placeholder, rightIcon, iconRightLabel, onRightIconPress, onRightIconLabelPress, label, errorText, style, onChangeValue, clearErrors, inputStyle, secureText, inputContainerStyle, onFieldPress, display = true, onRightButtonPress, rightButtonStyle, showRightButton = false, maxLength = 40, } = props;
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const handleFocus = () => {
        display && setIsFocused(true);
    };
    const handleBlur = () => {
        setIsFocused(false);
    };
    return (react_1.default.createElement(react_native_1.View, { style: [{ marginTop: (0, scale_1.scale)(30) }, style] },
        react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.textIdLabel },
                label,
                isRequire && (react_1.default.createElement(CustomText_1.default, { style: {
                        color: "#F80F63",
                    } }, "*"))),
            iconRightLabel && (react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                    onRightIconLabelPress && onRightIconLabelPress();
                }, style: { marginLeft: (0, scale_1.scale)(12) } }, iconRightLabel))),
        react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
            react_1.default.createElement(react_native_1.View, { style: [
                    styles.inputContainer,
                    inputContainerStyle,
                    { backgroundColor: display ? '#FEFEFE' : "#DDDDDD" },
                    errorText && { borderColor: '#F80F63', backgroundColor: '#FDF3F3' },
                    isFocused && { borderColor: '#00AEEF', backgroundColor: '#FEFEFE' },
                ] },
                react_1.default.createElement(react_native_1.TextInput, { onPressIn: onFieldPress, autoCapitalize: "none", onChangeText: (text) => {
                        onChangeValue?.(text);
                        clearErrors?.();
                    }, secureTextEntry: secureText || false, maxLength: maxLength, textAlignVertical: "center", ...props, placeholder: placeholder, style: [styles.input, inputStyle], onFocus: handleFocus, editable: display, onBlur: handleBlur }),
                rightIcon ? (react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                        onRightIconPress?.();
                    }, style: styles.rightIcon }, rightIcon))
                    :
                        undefined),
            showRightButton && (react_1.default.createElement(button_1.SimpleButton, { onPress: onRightButtonPress, textStyle: {
                    color: Colors_1.default.primaryColor,
                }, title: "\u4F4F\u6240\u3092\u81EA\u52D5\u5165\u529B", style: [{ marginLeft: (0, scale_1.scale)(10) }, rightButtonStyle] }))),
        !!errorText && (react_1.default.createElement(CustomText_1.default, { style: styles.textError }, errorText))));
};
const styles = react_native_1.StyleSheet.create({
    textIdLabel: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(22),
        marginBottom: (0, scale_1.scale)(5),
    },
    inputContainer: {
        marginTop: (0, scale_1.scale)(5),
        flexDirection: "row",
        borderRadius: (0, scale_1.scale)(3),
        flex: 1,
        height: (0, scale_1.scale)(40),
        borderWidth: 1,
        borderColor: "#DDDDDD",
    },
    input: {
        height: (0, scale_1.scale)(40),
        fontSize: (0, scale_1.moderateScale)(15),
        fontWeight: react_native_1.Platform.OS === "ios" ? "300" : "normal",
        fontFamily: 'Hiragino Kaku Gothic Pro W3',
        paddingHorizontal: (0, scale_1.scale)(15),
        padding: (0, scale_1.scale)(0),
        color: "#282828",
        lineHeight: (0, scale_1.moderateScale)(18),
        flex: 1,
        outlineWidth: 0,
        // paddingLeft: scale(8),
    },
    rightIcon: {
        alignSelf: "center",
        marginRight: (0, scale_1.scale)(10),
    },
    textError: {
        color: "#F80F63",
        fontSize: (0, scale_1.moderateScale)(12),
        marginTop: (0, scale_1.scale)(8),
        lineHeight: (0, scale_1.scale)(16),
    },
});
exports.default = InputField;
